import React from 'react';
import {classes, style} from './doppe-action-widget-text-area.st.css';
import {TextArea} from '@wix/devzai-utils-react';
import {OmitStrict} from "@wix/devzai-utils-common";

export const DoppeActionWidgetTextArea = React.memo(React.forwardRef(function DoppeActionWidgetTextArea(props: DoppeActionWidgetTextArea.Props, ref: React.Ref<TextArea>) {
    const {
        hasError,

        className,
        ...htmlAttributes
    } = props;

    return (
        <TextArea
            {...htmlAttributes}
            className={style(classes.root, {hasError: hasError}, className)}
            lineHeight={24}
            ref={ref}
        />
    );
}));

export namespace DoppeActionWidgetTextArea {

    export interface Props extends OmitStrict<TextArea.Props, 'lineHeight'> {
        hasError?: boolean;
    }
}
